import { pessoaTermoLGPDStatusPendente } from './status';

export class PessoaTermoLGPD {
    id: number;
    codigoIntegracaoErp: string;
    cnpjCpf: string;
    nome: string;
    nomeFantasia: string;
    cep: string;
    logradouro: string;
    numero: string;
    bairro: string;
    nomeCidade: string;
    nomeEstado: string;
    status: number;
    dataImpressao: Date;
    idUsuarioImpressao: number;
    nomeUsuarioImpressao: string;
    dataAnexo: Date;
    idUsuarioAnexo: number;
    nomeUsuarioAnexo: string;
    urlAnexo: string;

    constructor() {
        this.status = pessoaTermoLGPDStatusPendente.id;
    }
}
